/* RESPONSIBLE TEAM: team-proactive-support */
import Controller from '@ember/controller';

export default class AppsAppOutboundSeriesNewController extends Controller {
  queryParams = ['mode', 'template_id'];
}
